import { Navigate, Outlet, useLocation } from 'react-router'

import { FullPageSpinner } from './full-page-spinner'
import { useUser } from './use-user'

export function ProtectedRoute() {
  const location = useLocation()
  const { user, isLoading } = useUser()

  if (isLoading) return <FullPageSpinner />
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/login?next=${next}`} replace />
  }
  return <Outlet />
}
